<div class="preloader-area">
    <div class="lds-hourglass"></div>
</div>
<app-header *ngIf="(company$ | async) as company; else loading" [company]="company"></app-header>
    <router-outlet></router-outlet>
<app-footer *ngIf="(company$ | async) as company; else loading" [company]="company"></app-footer>

<ng-template #loading>Loading...</ng-template>
